import { ensureEnum } from 'utils/tsHelpers';
import { colors } from 'ui/theme';

export enum BrandAffinityLevel {
  LOYAL = 'loyal',
  POSITIVE = 'positive',
  NEUTRAL = 'neutral',
  NEGATIVE = 'negative',
  UNSCORED = 'unscored',
}

export const BRAND_AFFINITY_COLORS = {
  [BrandAffinityLevel.LOYAL]: colors.purple100,
  [BrandAffinityLevel.POSITIVE]: colors.green90,
  [BrandAffinityLevel.NEUTRAL]: colors.cyan80,
  [BrandAffinityLevel.NEGATIVE]: colors.red60,
  [BrandAffinityLevel.UNSCORED]: colors.grey50,
};

export const ensureBrandAffinityLevel = (name: string) =>
  ensureEnum(name, BrandAffinityLevel, BrandAffinityLevel.UNSCORED);

export const BRAND_AFFINITY_NAMES_TO_I18N_KEYS = {
  [BrandAffinityLevel.LOYAL]: 'levels.loyal.name',
  [BrandAffinityLevel.POSITIVE]: 'levels.positive.name',
  [BrandAffinityLevel.NEUTRAL]: 'levels.neutral.name',
  [BrandAffinityLevel.NEGATIVE]: 'levels.negative.name',
  [BrandAffinityLevel.UNSCORED]: 'levels.unscored.name',
};

export const BRAND_AFFINITY_DESCRIPTION_TO_I18N_KEYS = {
  [BrandAffinityLevel.LOYAL]: 'levels.loyal.description',
  [BrandAffinityLevel.POSITIVE]: 'levels.positive.description',
  [BrandAffinityLevel.NEUTRAL]: 'levels.neutral.description',
  [BrandAffinityLevel.NEGATIVE]: 'levels.negative.description',
  [BrandAffinityLevel.UNSCORED]: 'levels.unscored.description',
};

export const BRAND_AFFINITY_TOOLTIP_I18N_KEYS = {
  [BrandAffinityLevel.LOYAL]: 'levels.loyal.tooltip',
  [BrandAffinityLevel.POSITIVE]: 'levels.positive.tooltip',
  [BrandAffinityLevel.NEUTRAL]: 'levels.neutral.tooltip',
  [BrandAffinityLevel.NEGATIVE]: 'levels.negative.tooltip',
  [BrandAffinityLevel.UNSCORED]: 'levels.unscored.tooltip',
};

export const getScoreDataByLevel = (level: BrandAffinityLevel) => ({
  brandText:
    BRAND_AFFINITY_NAMES_TO_I18N_KEYS[level] ||
    BRAND_AFFINITY_NAMES_TO_I18N_KEYS[BrandAffinityLevel.UNSCORED],
  description:
    BRAND_AFFINITY_DESCRIPTION_TO_I18N_KEYS[level] ||
    BRAND_AFFINITY_DESCRIPTION_TO_I18N_KEYS[BrandAffinityLevel.UNSCORED],
  toolTip:
    BRAND_AFFINITY_TOOLTIP_I18N_KEYS[level] ||
    BRAND_AFFINITY_TOOLTIP_I18N_KEYS[BrandAffinityLevel.UNSCORED],
});
